export default __webpack_public_path__ + "static/media/instagram_icon.f3084aeb.svg";